var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriversLicenseBackSample(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 204,
    viewBox: "0 0 326 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x83\x81\xE3\x82\xA7\xE3\x83\x83\xE3\x82\xAF\xE3\x82\xA4\xE3\x83\xB3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 148"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 72",
    x: 0.5,
    y: 0.5,
    width: 325,
    height: 203,
    rx: 9.5,
    fill: "#FDF8EA",
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 73",
    x: 13.4207,
    y: 13.3738,
    width: 298.165,
    height: 115.854,
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 75",
    x: 13.4207,
    y: 13.3738,
    width: 52.6707,
    height: 25.7379,
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 13",
    x1: 12.9207,
    y1: 39.1117,
    x2: 312.085,
    y2: 39.1117,
    stroke: "#CCCCCC",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 14",
    x1: 12.9207,
    y1: 61.8883,
    x2: 312.085,
    y2: 61.8883,
    stroke: "#CCCCCC",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 15",
    x1: 12.9207,
    y1: 84.665,
    x2: 312.085,
    y2: 84.665,
    stroke: "#CCCCCC",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 16",
    x1: 12.9207,
    y1: 107.442,
    x2: 312.085,
    y2: 107.442,
    stroke: "#CCCCCC",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 74",
    x: 227.11,
    y: 140.131,
    width: 84.4756,
    height: 47.5243,
    stroke: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\x82\x99\xE8\x80\x83",
    d: "M33.3798 21.3914H34.4358V24.2474H33.3798V21.3914ZM36.4878 21.3914H37.5558V24.2474H36.4878V21.3914ZM35.7078 26.7074H36.6078V32.3954H35.7078V26.7074ZM31.5438 22.3514H39.3318V23.3354H31.5438V22.3514ZM33.8958 28.1114H38.4438V28.8794H33.8958V28.1114ZM33.8958 29.7434H38.4438V30.5114H33.8958V29.7434ZM32.1678 24.6194H39.3798V25.6154H32.1678V24.6194ZM31.6878 24.6194H32.7198V27.2474C32.7198 27.6314 32.7038 28.0514 32.6718 28.5074C32.6478 28.9554 32.5958 29.4154 32.5158 29.8874C32.4358 30.3514 32.3158 30.8074 32.1558 31.2554C32.0038 31.6954 31.8078 32.0954 31.5678 32.4554C31.5198 32.3914 31.4398 32.3114 31.3278 32.2154C31.2238 32.1274 31.1158 32.0394 31.0038 31.9514C30.8998 31.8714 30.8118 31.8074 30.7398 31.7594C31.0278 31.3194 31.2358 30.8354 31.3638 30.3074C31.4998 29.7714 31.5878 29.2394 31.6278 28.7114C31.6678 28.1754 31.6878 27.6794 31.6878 27.2234V24.6194ZM33.3198 26.3714H38.5638V27.2234H34.2798V32.4314H33.3198V26.3714ZM38.1078 26.3714H39.0918V31.4234C39.0918 31.6474 39.0638 31.8274 39.0078 31.9634C38.9598 32.1074 38.8598 32.2154 38.7078 32.2874C38.5558 32.3594 38.3638 32.4034 38.1318 32.4194C37.8998 32.4434 37.6158 32.4514 37.2798 32.4434C37.2718 32.3234 37.2438 32.1794 37.1958 32.0114C37.1478 31.8434 37.0878 31.6994 37.0158 31.5794C37.2318 31.5874 37.4238 31.5914 37.5918 31.5914C37.7678 31.5914 37.8878 31.5874 37.9518 31.5794C38.0558 31.5714 38.1078 31.5154 38.1078 31.4114V26.3714ZM30.4758 21.3554L31.5198 21.6554C31.2958 22.3514 31.0278 23.0474 30.7158 23.7434C30.4118 24.4314 30.0758 25.0834 29.7078 25.6994C29.3398 26.3154 28.9518 26.8594 28.5438 27.3314C28.5198 27.2434 28.4718 27.1234 28.3998 26.9714C28.3358 26.8194 28.2638 26.6674 28.1838 26.5154C28.1118 26.3634 28.0438 26.2394 27.9798 26.1434C28.3238 25.7514 28.6478 25.2994 28.9518 24.7874C29.2638 24.2754 29.5478 23.7274 29.8038 23.1434C30.0678 22.5514 30.2918 21.9554 30.4758 21.3554ZM29.5158 24.4514L30.5598 23.3954L30.5958 23.4194V32.4434H29.5158V24.4514ZM41.1558 24.7754H51.5598V25.7474H41.1558V24.7754ZM42.0678 22.6514H48.8598V23.5874H42.0678V22.6514ZM45.0078 21.3074H46.1358V25.2554H45.0078V21.3074ZM49.5798 26.4074L50.2878 27.1634C49.7758 27.2994 49.1918 27.4234 48.5358 27.5354C47.8798 27.6394 47.2038 27.7274 46.5078 27.7994C45.8118 27.8714 45.1398 27.9314 44.4918 27.9794C44.4758 27.8674 44.4398 27.7354 44.3838 27.5834C44.3278 27.4234 44.2758 27.2954 44.2278 27.1994C44.6998 27.1594 45.1838 27.1114 45.6798 27.0554C46.1758 26.9994 46.6598 26.9394 47.1318 26.8754C47.6118 26.8114 48.0598 26.7394 48.4758 26.6594C48.8998 26.5794 49.2678 26.4954 49.5798 26.4074ZM50.1438 21.8354L51.0678 22.3394C50.2678 23.3314 49.3478 24.2474 48.3078 25.0874C47.2678 25.9194 46.1518 26.6674 44.9598 27.3314C43.7758 27.9874 42.5718 28.5554 41.3478 29.0354C41.2998 28.9554 41.2318 28.8594 41.1438 28.7474C41.0638 28.6354 40.9758 28.5274 40.8798 28.4234C40.7918 28.3114 40.7118 28.2194 40.6398 28.1474C41.8798 27.7154 43.0878 27.1834 44.2638 26.5514C45.4398 25.9194 46.5318 25.2074 47.5398 24.4154C48.5478 23.6154 49.4158 22.7554 50.1438 21.8354ZM43.9878 26.4554L45.1158 26.5874C45.0278 26.9874 44.9318 27.4114 44.8278 27.8594C44.7238 28.3074 44.6158 28.7394 44.5038 29.1554C44.3998 29.5634 44.2998 29.9274 44.2038 30.2474L43.0758 30.0794C43.1798 29.7674 43.2838 29.4034 43.3878 28.9874C43.4998 28.5714 43.6078 28.1434 43.7118 27.7034C43.8238 27.2554 43.9158 26.8394 43.9878 26.4554ZM49.1478 28.7354H50.2998C50.2998 28.7354 50.2958 28.7674 50.2878 28.8314C50.2798 28.8874 50.2718 28.9554 50.2638 29.0354C50.2638 29.1074 50.2558 29.1714 50.2398 29.2274C50.1438 29.7954 50.0478 30.2714 49.9518 30.6554C49.8558 31.0314 49.7518 31.3354 49.6398 31.5674C49.5358 31.8074 49.4158 31.9874 49.2798 32.1074C49.1358 32.2354 48.9838 32.3234 48.8238 32.3714C48.6638 32.4194 48.4718 32.4474 48.2478 32.4554C48.0558 32.4634 47.7958 32.4634 47.4678 32.4554C47.1398 32.4554 46.7918 32.4474 46.4238 32.4314C46.4158 32.2794 46.3798 32.1034 46.3158 31.9034C46.2518 31.7114 46.1718 31.5394 46.0758 31.3874C46.4358 31.4194 46.7878 31.4394 47.1318 31.4474C47.4758 31.4634 47.7198 31.4714 47.8638 31.4714C47.9918 31.4714 48.0958 31.4634 48.1758 31.4474C48.2558 31.4394 48.3278 31.4114 48.3918 31.3634C48.5358 31.2434 48.6678 30.9914 48.7878 30.6074C48.9158 30.2234 49.0318 29.6474 49.1358 28.8794L49.1478 28.7354ZM44.0118 28.7354H49.4358V29.6714H43.7598L44.0118 28.7354Z",
    fill: "#A59785"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line 7",
    x1: 14.3136,
    y1: 151.385,
    x2: 31.0541,
    y2: 151.385,
    stroke: "#CCCCCC",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 10",
    x1: 14.3136,
    y1: 163.675,
    x2: 31.0541,
    y2: 163.675,
    stroke: "#CCCCCC",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 12",
    x1: 14.3136,
    y1: 175.088,
    x2: 31.0541,
    y2: 175.088,
    stroke: "#CCCCCC",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 8",
    x1: 42.5081,
    y1: 151.353,
    x2: 182.648,
    y2: 151.353,
    stroke: "#CCCCCC",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 9",
    x1: 42.5081,
    y1: 163.236,
    x2: 182.648,
    y2: 163.236,
    stroke: "#CCCCCC",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 11",
    x1: 42.5081,
    y1: 175.12,
    x2: 182.648,
    y2: 175.12,
    stroke: "#CCCCCC",
    strokeWidth: 8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversLicenseBackSample);
export default __webpack_public_path__ + "static/media/drivers-license-back-sample.77c13c3aeec6f2d6354ec8157ffe5213.svg";
export { ForwardRef as ReactComponent };